export default "__VITE_ASSET__BD3nRTd3__"